var lastOpen = null;
var headerHeight = $('.aad-site-header').outerHeight();
$('#menu-overlay').css('margin-top', headerHeight);


$('#mobile-hamburger').on('click', function(){
  if ($('#site-navigation').hasClass('nav-open')) {;
    $('#site-navigation').removeClass('nav-open');
  } else {
    $('#site-navigation').addClass('nav-open');
  }
});

$('.dropdown-toggle').on('click', function() {
  var itemID = $(this).parent().attr('id');

  if (itemID == lastOpen) {
    $('#menu-overlay').toggle().css('margin-top', headerHeight);
    $('html').toggleClass('overflow-hidden');
    itemID = null;
  } else if (lastOpen == null) {
    $('#menu-overlay').toggle();
    $('html').toggleClass('overflow-hidden');
  }
  lastOpen = itemID;
});

$('#menu-overlay').on('click', function(e) {
  e.stopPropagation();
});

$('#menu-overlay, body').on('click', function(e) {
  if ($(e.target).closest('.dropdown-toggle').length === 0) {
    $(".dropdown-toggle").each(function() {
      $(this).dropdown('hide');
    });
    $('#menu-overlay').hide();
    $('html').removeClass('overflow-hidden');
    lastOpen = null;
  }
});